module.exports = __webpack_public_path__ + "img/sticker-ru25x25.7845861e.jpg";